import { useTranslation } from 'react-i18next';
import { Linkedin, Mail, Github, BookOpen } from 'lucide-react';
import { Link } from 'react-router-dom';
import { personalInfo } from '@/data/portfolioConfig';

export default function Footer() {
  const { t } = useTranslation();

  const socialIcons = [
    {
      icon: Linkedin,
      href: personalInfo.linkedin,
      label: 'LinkedIn di Cristian Tesconi',
      gradient: 'from-blue-600 to-blue-400',
      shadow: 'hover:shadow-blue-500/50',
      external: true
    },
    {
      icon: Mail,
      href: '/contact',
      label: 'Email Cristian Tesconi',
      gradient: 'from-purple-600 to-pink-500',
      shadow: 'hover:shadow-purple-500/50',
      external: false,
      internal: true
    },
    {
      icon: Github,
      href: personalInfo.github,
      label: 'GitHub di Cristian Tesconi',
      gradient: 'from-gray-800 to-gray-600',
      shadow: 'hover:shadow-gray-500/50',
      external: true
    },
    {
      icon: BookOpen,
      href: 'https://www.amazon.it/stores/author/B0CC29G6VV',
      label: 'Libri di Cristian Tesconi su Amazon',
      gradient: 'from-orange-500 to-yellow-400',
      shadow: 'hover:shadow-orange-500/50',
      external: true
    }
  ];

  return (
    <footer className="relative bg-surface dark:bg-dark-bg text-gray-900 dark:text-light-text py-12 border-t-4 border-primary/20 dark:border-primary/40 overflow-hidden">
      {/* Decorative background */}
      <div className="absolute inset-0 opacity-30 dark:opacity-40">
        <div className="absolute top-0 left-1/4 w-64 h-64 bg-gradient-to-br from-primary/20 dark:from-primary/30 to-transparent rounded-full blur-3xl" />
        <div className="absolute bottom-0 right-1/4 w-64 h-64 bg-gradient-to-tl from-secondary/20 dark:from-secondary/30 to-transparent rounded-full blur-3xl" />
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        <div className="flex flex-col md:flex-row justify-between items-center gap-6">
          <p className="text-sm font-bold bg-gradient-to-r from-gray-800 to-gray-600 dark:from-white dark:to-gray-300 bg-clip-text text-transparent">
            © {new Date().getFullYear()}{' '}
            <a href="https://cristiantesconi.it" rel="author" className="hover:underline">
              Cristian Tesconi
            </a>
            . {t('footer.rights')}
          </p>

          <div className="flex items-center gap-4">
            {socialIcons.map((social, index) => {
              const cls = `group relative overflow-hidden p-4 rounded-2xl bg-white dark:bg-dark-bg-elevated border-2 border-border dark:border-primary/20 hover:border-transparent hover:scale-110 hover:-translate-y-2 transition-all duration-300 shadow-xl ${social.shadow}`;
              const inner = (
                <>
                  <div className={`absolute inset-0 bg-gradient-to-br ${social.gradient} opacity-0 group-hover:opacity-100 transition-opacity duration-300`} />
                  <social.icon className="relative z-10 h-6 w-6 text-gray-600 dark:text-gray-300 group-hover:text-white group-hover:rotate-12 transition-all duration-300" />
                </>
              );
              return (social as any).internal ? (
                <Link key={index} to={social.href} className={cls} aria-label={social.label}>
                  {inner}
                </Link>
              ) : (
                <a
                  key={index}
                  href={social.href}
                  target={social.external ? '_blank' : undefined}
                  rel={social.external ? 'noopener noreferrer' : undefined}
                  className={cls}
                  aria-label={social.label}
                >
                  {inner}
                </a>
              );
            })}
          </div>
        </div>
      </div>
    </footer>
  );
}

